// extracted by mini-css-extract-plugin
module.exports = {"uploads_wrapper":"picturewall_uploads_wrapper__27NhD","photoTitle":"picturewall_photoTitle__1ilSw"};